import { render, staticRenderFns } from "./tutor-list.vue?vue&type=template&id=deb5744a&scoped=true&"
import script from "./tutor-list.vue?vue&type=script&lang=js&"
export * from "./tutor-list.vue?vue&type=script&lang=js&"
import style0 from "./tutor-list.vue?vue&type=style&index=0&id=deb5744a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb5744a",
  null
  
)

export default component.exports